import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MessageCircleIcon } from 'lucide-react';
import { WHATSAPP_URL } from '../lib/constants';
export function FloatingWhatsApp() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 520);
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-49" data-mp="3jsexyadlg52f">
      {visible && <motion.a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" aria-label="Escríbeme por WhatsApp" initial={{
      opacity: 0,
      scale: 0.7,
      y: 20
    }} animate={{
      opacity: 1,
      scale: 1,
      y: 0
    }} exit={{
      opacity: 0,
      scale: 0.7,
      y: 20
    }} whileHover={{
      scale: 1.06,
      rotate: -3
    }} whileTap={{
      scale: 0.94
    }} className="fixed bottom-5 right-5 z-50 flex h-14 w-14 items-center justify-center rounded-full border-2 border-ink bg-lime text-ink shadow-[4px_4px_0_#12131A] focus:outline-none focus-visible:ring-4 focus-visible:ring-brand-300" data-id="element-50" data-mp="3jrlxfr58absq">
          <MessageCircleIcon className="h-6 w-6" data-id="element-51" data-mp="3ffr7r9gboeso" />
        </motion.a>}
    </AnimatePresence>;
}